import { useNavigate } from "react-router-dom";
import { Copy, ExternalLink, Pencil, Trash2, Link2, Upload, FileText } from "lucide-react";
import { toast } from "sonner";
import { api, fmtDuration } from "@/lib/api";

export const publicUrl = (slug) => `${window.location.origin}/c/${slug}`;

export const StatusBadge = ({ status }) => (
  <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${status === "active" ? "border-emerald-500/30 text-emerald-300 bg-emerald-500/10" : "border-slate-500/30 text-slate-400 bg-slate-500/10"}`}>
    <span className={`w-1.5 h-1.5 rounded-full ${status === "active" ? "bg-emerald-400" : "bg-slate-500"}`} />
    {status === "active" ? "Active" : "Draft"}
  </span>
);

export const CampaignRow = ({ c, onChanged }) => {
  const nav = useNavigate();
  const s = c.stats;
  const copy = (e) => { e.stopPropagation(); navigator.clipboard.writeText(publicUrl(c.slug)); toast.success("Landing page link copied"); };
  const del = async (e) => {
    e.stopPropagation();
    if (!window.confirm(`Delete "${c.name}" and all its analytics?`)) return;
    await api.delete(`/campaigns/${c.id}`);
    toast.success("Campaign deleted");
    onChanged();
  };
  const btn = "h-8 w-8 grid place-items-center rounded-md text-slate-400 hover:text-white hover:bg-white/5 transition-colors";
  return (
    <tr data-testid={`campaign-row-${c.slug}`} onClick={() => nav(`/admin/campaigns/${c.id}`)}
      className="border-t border-[#242C3D] hover:bg-[#1D2433] cursor-pointer transition-colors">
      <td className="px-6 py-4">
        <div className="flex items-center gap-3">
          <span className="w-8 h-8 rounded-md bg-[#0B0F17] border border-[#242C3D] grid place-items-center">
            {c.campaign_type === "whitepaper" ? <FileText className="w-3.5 h-3.5 text-amber-400" /> : c.video_type === "upload" ? <Upload className="w-3.5 h-3.5 text-cyan-400" /> : <Link2 className="w-3.5 h-3.5 text-indigo-400" />}
          </span>
          <div>
            <div className="font-medium text-slate-100">{c.name}</div>
            <div className="font-mono text-xs text-slate-500">/c/{c.slug}</div>
          </div>
        </div>
      </td>
      <td className="px-4 py-4"><StatusBadge status={c.status} /></td>
      <td className="px-4 py-4 text-right font-mono">{s.visits}</td>
      <td className="px-4 py-4 text-right font-mono">{s.leads}</td>
      <td className="px-4 py-4 text-right font-mono text-emerald-300">{s.conversion_rate == null ? "—" : `${s.conversion_rate}%`}</td>
      <td className="px-4 py-4 text-right font-mono">{fmtDuration(s.avg_watch_seconds)}</td>
      <td className="px-6 py-4">
        <div className="flex justify-end gap-1">
          <button data-testid={`campaign-copy-link-${c.slug}`} onClick={copy} className={btn} title="Copy link"><Copy className="w-4 h-4" /></button>
          <a data-testid={`campaign-open-link-${c.slug}`} href={`/c/${c.slug}`} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} className={btn} title="Open landing page"><ExternalLink className="w-4 h-4" /></a>
          <button data-testid={`campaign-edit-${c.slug}`} onClick={(e) => { e.stopPropagation(); nav(`/admin/campaigns/${c.id}/edit`); }} className={btn} title="Edit"><Pencil className="w-4 h-4" /></button>
          <button data-testid={`campaign-delete-${c.slug}`} onClick={del} className={`${btn} hover:!text-rose-400`} title="Delete"><Trash2 className="w-4 h-4" /></button>
        </div>
      </td>
    </tr>
  );
};
